let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7T7KD")).then(() => parcelRequire('kePQf'));